/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { Select, InputAdornment, FormControl, MenuItem } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MagnifyingGlass from '../../../../../Assets/images/svg/dar_magnifying.svg';
import sortIcon from '../../../../../Assets/images/svg/dar_sort.svg';
import styles from './header.module.scss';

const HeaderSection = ({ handlePopoverOpen ,hasAccess }) => {
  return (
    <div className={styles['header-section']}>
      <div className={styles['search-filter-container']}>
        <div className={styles['certification-search']}>
          <img src={MagnifyingGlass} alt="Search" />
          <input id="certification-search-input" type="text" placeholder="Search..." />
        </div>
        <FormControl className={styles['workflow-sort-dropdown']} sx={{  maxWidth: '300px' }} variant="standard">
          <Select
            fullWidth 
            displayEmpty
            IconComponent={KeyboardArrowDownIcon}
            startAdornment={
              <InputAdornment position="start">
                <img src={sortIcon} className={styles['filter-icon']} alt="sort" />
              </InputAdornment>
            }
            renderValue={(selected) => {
              if (!selected) {
                return <div  className={styles['sort']}>Sort by deal value</div>; //
              }
              return selected;
            }}
            sx={{
              '&:before': {
                borderBottom: '1px solid #CAC4CF', 
              },
              '&:after': {
                borderBottom: '1px solid #CAC4CF',
              },
              '&:hover:not(.Mui-disabled):before': {
                borderBottom: '1px solid #CAC4CF', 
              },
            }}
          >
            <MenuItem value="">Select an option</MenuItem>
            <MenuItem value={1}>Option 1</MenuItem>
            <MenuItem value={2}>Option 2</MenuItem>
            <MenuItem value={3}>Option 3</MenuItem>
          </Select>
        </FormControl>
      </div>
      <button className={styles['add-button']} onClick={(e) => handlePopoverOpen(e)} disabled={!hasAccess('create')}
      style={{
        cursor: hasAccess('create') ? 'pointer' : 'not-allowed',
        opacity: hasAccess('create') ? 1 : 0.5,
      }}
>
        +Add 
      </button>
    </div>
  );
};
HeaderSection.propTypes = {
  handlePopoverOpen: PropTypes.func.isRequired,
  hasAccess: PropTypes.bool.isRequired,
};

export default HeaderSection;